import React from 'react';
import Img from '../../common/util/Img';
import { getStreamingId } from '../../data/streaming/streamingUtils';

function CalendarMatch(props) {
    const streamingId = getStreamingId(props.streaming);
    
    return (
        <tr>
            <td>{props.sport}</td>
            <td>{props.competition}</td>
            <td>{props.match}</td>
            {streamingId &&
                <td>
                    <Img src="assets\img\sport\icone\tv-streaming.svg" alt="" className="img-tv-streaming"></Img>
                </td>
            }
            <td>{props.time}</td>
        </tr>
    );
}

export default CalendarMatch;